module.exports = __webpack_public_path__ + "img/jak-right.3f79b5da.png";